import { selectOptionConvert } from '../../helpers/selectOptionConvert';
import { TimeHorizonsBase } from '../Base/TimeHorizons';

export const TKATimeHorizons = selectOptionConvert(TimeHorizonsBase);
